export class FbTipPrice {
  public purchased: boolean;
  public tipPrice: number;
  public voucherCost: number;
  public canUseVoucher: boolean;
  public allowVoucher: boolean;
  public voucherBalance: number;

  constructor (purchased: boolean, tipPrice: number, voucherCost: number, canUseVoucher: boolean, allowVoucher: boolean, voucherBalance: number) {
    this.purchased = purchased;
    this.tipPrice = tipPrice;
    this.voucherCost = voucherCost;
    this.canUseVoucher = canUseVoucher;
    this.allowVoucher = allowVoucher;
    this.voucherBalance = voucherBalance;
  }
}



// WEBPACK FOOTER //
// ./src/model/FbTipPrice.ts